export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 1_14.48356f28.jpg";